import styled from "styled-components";

import { TruncatedTextCell } from "@similarweb/pro-logic-components";

// Virtualized table cells are display:flex and BaseCell renders an inline <span>, which establishes no
// definite width for text-overflow to resolve against. block + overflow:hidden restores truncation.
export const StyledTruncatedTextCell = styled(TruncatedTextCell)`
    display: block;
    overflow: hidden;
`;
